import type { InjectionKey, Ref } from "vue";

export const nameInjectionKey = Symbol("nameInjectionKey") as InjectionKey<string>;
export const formNavigationKey = Symbol("formNavigationKey") as InjectionKey<{
    enable: () => void,
    disable: (message: string) => void,
}>;

export const resultPremiumsKey = Symbol("resultPremiumsKey") as InjectionKey<{
    activePremium: Ref<number | null>,
    togglePremium: (premiumId: number) => void,
}>;
